import Progress from '../elements/userupload/Progress'
import ModalWrapper from '../modals/ModalWrapper'
import Step from '../elements/userupload/Step';
import { UserImportFieldOptionsModel } from '../../models/ApiResponseModels/UserImportFieldOptionsModel';
import { UserUploadActionProgress } from '../../models/ApiResponseModels/UserUploadActionProgressModel';
import { UserImportType } from  '@/models/UserImportType';
import { UserImportStep } from  '@/models/UserImportStep';

interface BulkImportUsersProps {
    isOpen: boolean
    displayCloseButton: boolean
    formValid: boolean
    closeModal: ()=> void;
    Cancel: () => void
    stepProps: StepProps
    NextStep: () => void
    Loading: boolean
    responseError: {message: string, code: number},
    currentStep:UserImportStep,
    setUploadType:(type: UserImportType)=> void,
    uploadType:UserImportType
}

interface StepProps {
    userImportOptions: UserImportFieldOptionsModel[]
    setFile: (value: HTMLInputElement) => void
    progressReport: UserUploadActionProgress
    SetValid: (value: boolean) => void
    currentStep: UserImportStep,
    setUserImportOptions:(value: UserImportFieldOptionsModel[]) => void
    setUploadType:(type: UserImportType)=> void,
    uploadType:UserImportType
}

const BulkImportUsersModal = (props: BulkImportUsersProps) => {

    const {
        isOpen,
        displayCloseButton,
        formValid,
        closeModal,
        Cancel,
        stepProps, 
        NextStep,
        Loading,
        responseError,
        currentStep
    } = props
    
    function getCurrentStepNumberForProgress(){
        switch (stepProps.currentStep){
            case UserImportStep.FileUpload:
                return 1;
            case UserImportStep.UserOptions:
                return 2;
            case UserImportStep.Validation:
                if(stepProps.uploadType == UserImportType.Fullsync){
                    return 3;
                }
                return 2;
            case UserImportStep.ReviewAndApplyChanges:
                if(stepProps.uploadType == UserImportType.Fullsync){
                    return 4;
                }
                return 3;
            default:
                return 0;
        }
    }

    return (
        
        <ModalWrapper hideCloseButton={stepProps.currentStep === 5} className={`user-upload-modal ${currentStep == 1 ? 'first-step' : ''}`} isOpen={isOpen} escClose={false} onRequestClose={closeModal}>      
                        
            <h2>Bulk Import Users</h2>

            {currentStep > 1 ? <Progress count={getCurrentStepNumberForProgress()} total={stepProps.uploadType == UserImportType.Fullsync ? 5 : 3} /> : null}    

            <Step {...{...stepProps, responseError}} />

            {displayCloseButton && 
            
                <div className="upload-nav">

                    <button
                        className="user-upload-btn-clear btn" 
                        onClick={closeModal}
                    >
                        Close Modal
                    </button>

                </div>
            }

            {!displayCloseButton && 

                <div className="upload-nav">
                    <button className="btn-blue btn" disabled={!formValid || Loading || !!responseError} onClick={() => NextStep()}>                         
                        {stepProps.currentStep !== UserImportStep.ReviewAndApplyChanges ? 'Next Step' : 'Apply Changes and Complete'}
                    </button>

                    <button 
                        className={`user-upload-btn-clear btn${stepProps.currentStep === UserImportStep.Validation ? ' disabled':''}`} 
                        disabled={ stepProps.currentStep === UserImportStep.Validation} 
                        onClick={() => Cancel()}>{stepProps.currentStep === UserImportStep.ReviewAndApplyChanges ? 'Abandon and Close' : 'Cancel'}
                    </button>   
                </div>
            }

        </ModalWrapper>    
    )

}
    
export default BulkImportUsersModal